<div class="create-topic-modal">
    <Modal
        id="create-topic-modal-id"
        {i18n}
        {body}
        heading={config.createTopicText}
        showCloseButton={false}
        on:modalClosed={cancel}
        closeable={false}
    >
        <div slot="body" class="topic-modal__container">
            <div class="topic-modal__info">{i18n.topicInformation}</div>
            <TextField
                id={topicModalInputId}
                label={i18n.titleHeader}
                labelHidden={false}
                bind:value={topicTitle}
                type="text"
                placeholder={i18n.createTopicTitlePlaceholder}
                required={true}
                minlength={minTitleLength}
                maxlength={maxTitleLength}
                height="medium"
                on:keyup={checkIfEmptyTitle}
            />
            <ColorPicker
                colours={config.topicColours}
                {disabled}
                label={i18n.topicColourText}
                {name}
                bind:selected={selectedColour}
            />
        </div>

        <div slot="footer">
            <Button
                type="primary"
                large={true}
                text={i18n.create}
                disabled={disableCreateButton}
                on:click={create}
            />
            <Button type="secondary" large={true} text={i18n.cancel} on:click={cancel} />
        </div>
    </Modal>
</div>

<script>
    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v1/Modal.svelte";
    import ColorPicker from "@itslearning/prometheus/assets/inputs/ColorPicker/v1/ColorPicker.svelte";
    import TextField from "@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte";
    import { createEventDispatcher, onMount } from "svelte";
    import i18n from "../../i18n.js";
    import config from "../../config";
    import { getTopicRandomColour } from "../../api";
    import { minTitleLength, maxTitleLength } from "../../constants";

    export let topicTitle;
    export let body;

    export let disabled = false;
    export let name = "topic-color-picker";
    export let selectedColour = undefined;
    export let autoSelectedColourId;

    let disableCreateButton = true;

    const topicModalInputId = "topic-modal-input-id";

    onMount(async () => {
        try {
            const data = await getTopicRandomColour();
            autoSelectedColourId = data.topicColorSchema;
            config.topicColours.forEach(function (colour) {
                if (colour.id === autoSelectedColourId) {
                    selectedColour = colour.className;
                }
            });

            if (selectedColour === undefined) {
                selectedColour = config.topicColours[0] ? config.topicColours[0].className : "olympicblue--100";
            }
        } catch (error) {
            selectedColour = config.topicColours[0] ? config.topicColours[0].className : "olympicblue--100";
        }

        const focusElement = "#prom-input-" + topicModalInputId;

        if (document.querySelector(focusElement)) {
            document.querySelector(focusElement).focus();
        }
    });

    const dispatch = createEventDispatcher();

    function create() {
        disableCreateButton = true;
        let selectedColourId = 1;

        config.topicColours.forEach(function (colour) {
            if (colour.className === selectedColour) {
                selectedColourId = colour.id;
            }
        });
        dispatch("createTopic", {
            title: topicTitle,
            colour: selectedColourId
        });
    }

    function cancel() {
        dispatch("cancel");
    }

    function checkIfEmptyTitle() {
        if (topicTitle && topicTitle.length > 0) {
            disableCreateButton = false;
        } else {
            disableCreateButton = true;
        }
    }
</script>
